// Generated by openapi-codegen. Do not edit manually.

import * as z from 'zod';

export const v1CostSchema = z.object({
  fractional: z.number().int(),
  formatted: z.coerce.string().min(1),
  amount: z.number(),
  currency_code: z.coerce.string().min(1),
});
